import {
  BRASS_CZ_COLOUR_STONE_IMITATION,
  BRASS_IMITATION_DISPLAY_LABEL,
  LEGACY_PLATINUM_GOLD_STUDDED,
  STAINLESS_FASHION_DISPLAY_LABEL,
  STAINLESS_FASHION_LABEL,
  normalizeCatalogToken,
} from "./materialCatalog";

const MATERIAL_ALIASES = {
  [BRASS_CZ_COLOUR_STONE_IMITATION]: [
    BRASS_CZ_COLOUR_STONE_IMITATION,
    BRASS_IMITATION_DISPLAY_LABEL,
    "BRASS-CZ-COLOR STONE",
    "BRASS-CZ-COLOUR STONE",
    "BRASS-CZ-COLOR STONE (IMITATION)",
    "BRASS-CZ-COLOUR STONE (IMITATION)",
  ],
  [STAINLESS_FASHION_LABEL]: [
    STAINLESS_FASHION_LABEL,
    STAINLESS_FASHION_DISPLAY_LABEL,
    "STEEL JEWELLERY",
    "STEEL JEWELRY",
    "STAINLESS FASHION",
    "STAINLESS STEEL",
  ],
  "Silver-Plain": ["Silver-Plain", "SILVER-PLAIN"],
  "Silver-CZ-Colour Stones": [
    "Silver-CZ-Colour Stones",
    "SILVER-CZ-COLOUR STONES",
    "SILVER-CZ-COLOUR STONE",
    "SILVER-CZ-COLOR STONES",
    "SILVER-CZ-COLOR STONE",
    "SILVER- CZ-COLOR STONE",
  ],
  "Silver-LGD": ["Silver-LGD", "SILVER-LGD", "SILVER-CVD (LGD)", "SILVER-CVD (LAB GROWN DIA.)"],
  "Silver-Natural Diamonds": ["Silver-Natural Diamonds", "SILVER-NATURAL DIAMONDS", "SILVER-NATURAL DIAMOND"],
  "Gold-Plain": ["Gold-Plain", "GOLD-PLAIN"],
  "Gold-CZ-Colour Stones": [
    "Gold-CZ-Colour Stones",
    "GOLD-CZ-COLOUR STONES",
    "GOLD-CZ-COLOUR STONE",
    "GOLD-CZ-COLOR STONES",
    "GOLD-CZ-COLOR STONE",
  ],
  "Gold-LGD": [
    "Gold-LGD",
    "GOLD-LGD",
    "GOLD-CVD (LGD)",
    "GOLD- CVD (LGD)",
    "GOLD- CVD(LGD)",
    "GOLD-CVD (LAB GROWN DIA.)",
    "GOLD- CVD(LAB GROWN DIA.)",
  ],
  "Gold-Natural Diamonds": ["Gold-Natural Diamonds", "GOLD-NATURAL DIAMONDS", "GOLD-NATURAL DIAMOND"],
  "Platinum-Plain": ["Platinum-Plain", "PLATINUM-PLAIN"],
  "Platinum-LGD": ["Platinum-LGD", "PLATINUM-LGD", "PLATINUM-CVD (LGD)", "PLATINUM-CVD (LAB GROWN DIA.)"],
  "Platinum-Natural Diamonds": ["Platinum-Natural Diamonds", "PLATINUM-NATURAL DIAMONDS", "PLATINUM-NATURAL DIAMOND"],
  "Platinum-Gold-Plain": ["Platinum-Gold-Plain", "PLATINUM-GOLD-PLAIN"],
  "Platinum-Gold-LGD": ["Platinum-Gold-LGD", "PLATINUM-GOLD-LGD"],
  "Platinum-Gold-Natural Diamonds": [
    "Platinum-Gold-Natural Diamonds",
    "PLATINUM-GOLD-NATURAL DIAMONDS",
    "PLATINUM-GOLD-NATURAL DIAMOND",
  ],
  [LEGACY_PLATINUM_GOLD_STUDDED]: [
    LEGACY_PLATINUM_GOLD_STUDDED,
    "PLATINUM-GOLD-STUDDED (LGD/NATURAL)",
    "PLATINUM-GOLD-STUDDED (LGD/NAT.)",
  ],
  "GOMATI CHAKRA": ["GOMATI CHAKRA", "GOMTI CHAKRA"],
};

const aliasLookup = Object.entries(MATERIAL_ALIASES).reduce((lookup, [canonicalValue, aliases]) => {
  aliases.forEach((alias) => {
    lookup.set(normalizeCatalogToken(alias), canonicalValue);
  });
  return lookup;
}, new Map());

export const normalizeMaterialLabel = (value = "") => {
  const trimmedValue = String(value || "").trim().replace(/\s+/g, " ");

  if (!trimmedValue) {
    return "";
  }

  return aliasLookup.get(normalizeCatalogToken(trimmedValue)) || trimmedValue;
};

export const formatMaterialDisplayLabel = (value = "") => {
  const normalizedLabel = normalizeMaterialLabel(value);

  if (normalizedLabel === STAINLESS_FASHION_LABEL) {
    return STAINLESS_FASHION_DISPLAY_LABEL;
  }

  if (normalizedLabel === BRASS_CZ_COLOUR_STONE_IMITATION) {
    return BRASS_IMITATION_DISPLAY_LABEL;
  }

  return normalizedLabel;
};
